import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { queryClient } from "../../../../../../../utils/queryClient";
// dates
import { ptBR } from "date-fns/locale";
import { addDays, format, parseISO } from "date-fns";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
//components
import Input from "../../../../../../../components/input/Input";
import Select from "../../../../../../../components/input/Select";
import Toggle from "../../../../../../../components/button/Toggle";
import NumberInput from "../../../../../../../components/input/NumberInput";
import CalendarInput from "../../../../../../../components/input/CalendarInput";
//services
import { getIndex } from "../../../../../../../services/GlobalRoles/getIndex";
import { patchSale } from "../../../../../../../services/Contracts/patchSale";
import { getOutstandingBalance } from "../../../../../../../services/GlobalRoles/getOutstandingBalance";
//context
import { useAppContext } from "../../../../../../../context/AppContext";

const CreateInfo = ({ name, content, icon, column }) => {
  return (
    <div className={`${column ? column : "col-xl-6"} d-flex`}>
      <p className="fw-bold">
        {" "}
        <span className="mx-2">{icon}</span>
        {name}
      </p>
      <span className="mx-2">{content}</span>
    </div>
  );
};

const CreateTable = ({ info, value, legend }) => {
  return (
    <div className="d-flex py-1 justify-content-between">
      <div className="col-xl-4 col-md-4">
        <p>{info}</p>
      </div>
      <div className="col-xl-2 col-md-4">
        <p>{value}</p>
      </div>
      <div className="col-xl-6 col-md-4">
        <p>{legend}</p>
      </div>
    </div>
  );
};

const Contract = ({
  setActiveIndex,
  id,
  isLoadingContract,
  visibleModalStopSale,
  setVisibleModalStopSale,
}) => {
  const [selectIndexData, setSelectIndexData] = useState([]);
  const [cellNumber, setCellNumber] = useState("");
  const [fixNumber, setFixNumber] = useState("");
  const [dataFormatadaEscrita, setdataFormatadaEscrita] = useState("");
  const [horario, setHorario] = useState("");
  const [comercialNumber, setcomercialNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const contract = queryClient.getQueryData(`sale${id}`);
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const { data: index, isLoading: loadingIndex } = useQuery({
    queryKey: ["index"],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149"),
  });

  // const { data: hasShipping, isLoading: isLoadingShipping } = useQuery({
  //   queryKey: ["hasShipping"],
  //   queryFn: () => getExistShipping(id),
  // });

  const { data: outstandingBalance } = useQuery({
    queryKey: [`outstandingBalance_${id}`],
    queryFn: () => getOutstandingBalance(id),
    enabled: !!permissions?.includes("37"),
  });

  useEffect(() => {
    if (index) {
      setSelectIndexData(
        index.map((dado) => ({
          value: dado.id,
          label: dado.name,
        }))
      );
    }
  }, [index]);

  const getNumbers = (contract) => {
    contract.cli.contacts.forEach((n) => {
      if (n.type_number === 1) {
        setCellNumber(n.number);
      }
      if (n.type_number === 2) {
        setFixNumber(n.number);
      }
      if (n.type_number === 2) {
        setcomercialNumber(n.number);
      }
    });
  };

  useEffect(() => {
    if (contract) {
      // console.log(contract)
      const dataEscrita = parseISO(contract.config.created_at);
      // const data = dataHoraObj.toISOString().slice(0, 10);
      setdataFormatadaEscrita(
        format(dataEscrita, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })
      );
      const horario = contract.config.created_at.substring(11, 19);
      setHorario(horario);
      form.setValue(
        "amortization_system",
        contract.config.amortization_system?.toUpperCase()
      );
      form.setValue("index_id", contract.config.index_reajusted_id);
      form.setValue("reserve_fund", contract.config.reserve_fund);
      form.setValue("intermediate_rate", contract.config.intermediate_rate);
      form.setValue("financing_rate", contract.config.financing_rate);
      form.setValue("readjust", contract.config.readjust);
      form.setValue("signature", contract.config.signature);
      form.setValue("scanned", contract.config.scanned);
      form.setValue("concluded", contract.config.contract_completed);
      form.setValue(
        "date_readjust",
        new Date(
          contract.config.date_readjust || new Date(contract.config.created_at)
        )
      );
      form.setValue("new_date_contract", new Date(contract.config.created_at));
      getNumbers(contract);
    }
  }, [contract]);

  const formatData = (str) => {
    const string = str.split(" ");
    const dataObj = parseISO(string[0]);
    const dataFormatada = format(dataObj, "dd/MM/yyyy");
    return dataFormatada;
  };

  const formatMoney = (str) => {
    const numeroFormatado = str.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
    return numeroFormatado;
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const { mutateAsync: patchSaleFn } = useMutation({
    mutationFn: patchSale,
    onSuccess(_, variables) {
      queryClient.setQueryData([`sale${id}`], (data) => {
        const dataEscrita = new Date(variables.new_date_contract);
        const agora = new Date();
        dataEscrita.setHours(
          agora.getHours(),
          agora.getMinutes(),
          agora.getSeconds()
        );
        const dataFormatada = format(dataEscrita, "dd 'de' MMMM 'de' yyyy", {
          locale: ptBR,
        });
        setdataFormatadaEscrita(dataFormatada);
        const horarioLocal = dataEscrita.toLocaleTimeString("pt-BR", {
          hour12: false,
        });
        setHorario(horarioLocal);
        data.config.created_at = variables.new_date_contract;
        data.config.date_readjust = variables.date_readjust;
        data.config.intermediate_rate = variables.intermediate_rate;
        data.config.financing_rate = variables.financing_rate;
        data.config.index_reajusted_id = variables.index_id;
        data.config.reserve_fund = variables.reserve_fund;
        data.config.readjust = variables.reajust;
        data.config.signature = variables.signature;
        data.config.scanned = variables.scanned;
        data.config.contract_completed = variables.concluded;
        return data;
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    function formatStringDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(new Date().getHours()).padStart(2, "0");
      const minutes = String(new Date().getMinutes()).padStart(2, "0");
      const seconds = String(new Date().getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    data.id = id;
    if (data.date_readjust) {
      data.date_readjust = formatStringDate(data.date_readjust);
    }
    if (data.new_date_contract) {
      data.new_date_contract = formatStringDate(data.new_date_contract);
    }
    const notification = toast.loading("Aguarde Para Salvar os Dados");
    try {
      await patchSaleFn(data);
      // console.log(response);
      toast.update(notification, {
        render: "Dados Cadastrados com Sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a editar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
    setLoading(false);
  };

  const form = useForm();
  const formStop = useForm();
  const errors = form.formState.errors;

  return (
    <>
      {isLoadingContract ? (
        <div className="row">
          <div className="d-flex justify-content-between">
            <div className="col-md-6">
              <Skeleton width="40%" height="50px" className="my-2"></Skeleton>
            </div>
            <div className="col-md-6 my-auto d-flex">
              <Skeleton width="40%" height="50px" className="my-2"></Skeleton>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6 my-4">
              <Skeleton
                width="95%"
                height="200px"
                className="mx-auto"
              ></Skeleton>
            </div>
            <div className="col-md-6 my-4">
              <Skeleton
                width="95%"
                height="200px"
                className="mx-auto"
              ></Skeleton>
            </div>
          </div>
          <hr />
          <div className="row">
            <Skeleton width="100%" height="500px" className=""></Skeleton>
          </div>
          <div>
            <hr className="my-3" />
            <div className="row">
              <Skeleton width="99%" height="300px" className=" "></Skeleton>
            </div>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="row justify-content-between">
            <div className="col-md-6">
              <h1>
                CONTRATO
                <span>
                  {" "}
                  <i className="fa-solid text-success fa-ellipsis fa-2xl"></i>
                </span>
              </h1>
              <h3 className="text-success">
                Contrato {contract.name_enterprise}
              </h3>
            </div>
            <div className="col-md-6 my-auto d-flex">
              <h1>
                <i className="fa-solid text-success fa-calendar-week fa-2xl"></i>
              </h1>
              <div className="mx-3">
                <h5>{dataFormatadaEscrita}</h5>
                <p>{horario !== "00:00:00" && horario}</p>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-xl-6 my-4">
              <div className="card-border h-100">
                <div className="title-container">
                  <p>
                    {" "}
                    <i className="pi pi-user me-2"></i>Informações do Cliente
                  </p>
                </div>
                <div className="row pt-3">
                  <CreateInfo
                    name="Cliente:"
                    content={contract.cli.name ? contract.cli.name : ""}
                    icon={<i className="fa-solid fa-user"></i>}
                  />
                  <CreateInfo
                    name="CPF:"
                    content={contract.cli.doc ? contract.cli.doc : ""}
                    icon={<i className="fa-solid fa-id-card"></i>}
                  />
                  <CreateInfo
                    name="RG:"
                    content={contract.cli.rg ? contract.cli.rg : "-"}
                    icon={<i className="fa-solid fa-id-card"></i>}
                  />
                  <CreateInfo
                    name="Celular:"
                    content={cellNumber ? cellNumber : "-"}
                    icon={<i className="fa-solid fa-phone-volume"></i>}
                  />
                  <CreateInfo
                    name="Tel Fixo:"
                    content={fixNumber ? fixNumber : "-"}
                    icon={<i className="fa-solid fa-phone-volume"></i>}
                  />
                  <CreateInfo
                    name="Tel Comercial:"
                    content={comercialNumber ? comercialNumber : "-"}
                    icon={<i className="fa-solid fa-phone-volume"></i>}
                  />
                  <CreateInfo
                    name="E-mail:"
                    content={contract.cli.email ? contract.cli.email : "-"}
                    icon={<i className="fa-solid fa-envelope"></i>}
                  />
                  <CreateInfo
                    name="Endereço:"
                    content={
                      contract.cli.address !== null
                        ? `Rua ${contract.cli.address.address}, ${contract.cli.address.num}, ${contract.cli.address.city} - ${contract.cli.address.state}, ${contract.cli.address.cep}`
                        : "-"
                    }
                    column="col-md-12"
                    icon={<i className="fa-solid fa-house"></i>}
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6 my-4">
              <div className="card-border h-100">
                <div className="title-container">
                  <p>
                    {" "}
                    <i className="fa-solid fa-map-location me-2"></i>Informações
                    da Venda
                  </p>
                </div>
                <div className="row pt-3">
                  <CreateInfo
                    name={`${nomenclature[0].value}:`}
                    content={contract.info.block}
                    icon={<i className="fa-solid fa-signs-post"></i>}
                  />
                  <CreateInfo
                    name={`${nomenclature[1].value}:`}
                    content={contract.info.land}
                    icon={<i className="fa-solid fa-location-pin"></i>}
                  />
                  <CreateInfo
                    name="M²:"
                    content={contract.info.m2}
                    icon={<i className="fa-solid fa-map-pin"></i>}
                  />
                  <CreateInfo
                    name="Matricula:"
                    content={
                      contract.info.num_register
                        ? contract.info.num_register
                        : "-"
                    }
                    icon={<i className="fa-solid fa-layer-group"></i>}
                  />
                  <CreateInfo
                    name="Data:"
                    content={
                      contract.config.created_at &&
                      formatData(contract.config.created_at)
                    }
                    icon={<i className="fa-solid fa-calendar-minus"></i>}
                  />
                  <CreateInfo
                    name="Código do Contrato:"
                    content={contract.id}
                    icon={<i className="fa-solid fa-qrcode"></i>}
                  />
                  <CreateInfo
                    name="Vendido Por:"
                    content={contract.info.seller_by}
                    icon={<i className="fa-solid fa-comments-dollar"></i>}
                  />
                  <CreateInfo
                    name="Cadastrado Por:"
                    content={contract.info.registered_by}
                    icon={<i className="fa-solid fa-address-book"></i>}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="pb-2 row justify-content-between">
              <div className="col-xl-4 col-md-4">
                <div className="inline-flex align-items-center text-success">
                  <i className="fa-solid fa-hand-holding-dollar  me-2"></i>
                  <b>Saldo Devedor</b>
                </div>
              </div>
              <div className="col-xl-2 col-md-4">
                <div className="inline-flex align-items-center text-success">
                  <i className="fa-solid fa-hand-holding-dollar  me-2"></i>
                  <b>R$ (Histórico)</b>
                </div>
              </div>
              <div className="col-xl-6 col-md-4">
                <div className="inline-flex align-items-center text-success">
                  <i className="fa-solid fa-hand-holding-dollar  me-2"></i>
                  <b>Legenda</b>
                </div>
              </div>
            </div>
            <CreateTable
              info="(A) Valor do Lote"
              value={
                contract.value_land > 0
                  ? formatMoney(contract.value_land)
                  : "R$ 0,00"
              }
              legend={`Valor do ${nomenclature[1].value}`}
            />
            <CreateTable
              info="(B) Desconto"
              value={
                contract.discount > 0
                  ? formatMoney(contract.discount)
                  : "R$ 0,00"
              }
              legend="Desconto Aplicado na Venda"
            />
            <CreateTable
              info="(C) Valor Venda"
              value={
                contract.value > 0 ? formatMoney(contract.value) : "R$ 0,00"
              }
              legend={`Valor do ${nomenclature[1].value} menos (-) o Desconto`}
            />
            <CreateTable
              info="(D) Valor Total em Aberto"
              value={
                contract.total_open > 0
                  ? formatMoney(contract.total_open)
                  : "R$ 0,00"
              }
              legend="Total de Parcelas em Aberto"
            />
            <CreateTable
              info="(E) Saldo devedor do Contrato"
              value={
                outstandingBalance &&
                formatMoney(outstandingBalance.outstandingBalance)
              }
              // value={0}
              legend="Contrato Amortizado + Multa e Juros Incidentes Sobre as Parcelas em Atraso"
            />
            <CreateTable
              info="(F) Juros e Multa Ref. Parcelas"
              value={
                contract.interest_fine > 0
                  ? formatMoney(contract.interest_fine)
                  : "R$ 0,00"
              }
              legend="Valor do Juros e Multa Incidentes Sobre as Parcelas em Atraso"
            />
            <CreateTable
              info="(G) Valor Atraso"
              value={
                contract.delay_value > 0
                  ? formatMoney(contract.delay_value)
                  : "R$ 0,00"
              }
              legend="	Valor de Parcelas em Atraso sem Multa / Juros"
            />
            <CreateTable
              info="(H) Valor Atraso + Juros e Multa Ref. Parcelas"
              value={
                contract.delay_value_interest_fine > 0
                  ? formatMoney(contract.delay_value_interest_fine)
                  : "R$ 0,00"
              }
              legend="	Valor de Parcelas em Atraso, Atualizado com Multa / Juros"
            />
            <CreateTable
              info="(I) Valor Pago"
              value={
                contract.total_pay > 0
                  ? formatMoney(contract.total_pay)
                  : "R$ 0,00"
              }
              legend="Valor Total de Parcelas Pagas"
            />
          </div>

          <div>
            <hr className="mb-2" />
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="row">
                <div className="card-border me-2 my-4">
                  <div className="title-container">
                    <p>
                      {" "}
                      <i className="fa-solid fa-sliders me-2"></i>Configurações
                      do Contrato
                    </p>
                  </div>
                  <div className="row pt-3">
                    <div className="col-xl-6 col-md-6">
                      <label className="pb-3">Data Inicial Reajuste:</label>
                      <CalendarInput
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="date_readjust"
                        control={form.control}
                        errors={errors}
                        maxDate={addDays(new Date(), 1)}
                      />
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <label className="pb-3">Data do Contrato:</label>
                      <CalendarInput
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="new_date_contract"
                        control={form.control}
                        errors={errors}
                        maxDate={addDays(new Date(), 1)}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-3">
                      <label className="pb-3">Taxa de Juros</label>
                      <NumberInput
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="financing_rate"
                        suffix="%"
                        placeholder="0%"
                        max={100}
                        minFractionDigits={2}
                        control={form.control}
                        errors={errors}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-3">
                      <label className="pb-3">
                        Taxa de Juros Intermediárias
                      </label>
                      <NumberInput
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="intermediate_rate"
                        suffix="%"
                        placeholder="0%"
                        max={100}
                        minFractionDigits={2}
                        control={form.control}
                        errors={errors}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-3">
                      <label className="pb-3">Sistema de Amortização</label>
                      <Input
                        name="amortization_system"
                        disabled={true}
                        control={form.control}
                        errors={errors}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-3">
                      <label className="pb-3">Índice Reajuste</label>
                      <Select
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="index_id"
                        control={form.control}
                        errors={errors}
                        options={selectIndexData}
                        preValue={
                          contract && contract.config.index_reajusted_id
                        }
                        label={loadingIndex ? "Carregando..." : ""}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-2">
                      <Toggle
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="readjust"
                        onLabel="Reajustar Contrato"
                        offLabel="Reajustar Contrato"
                        preValue={contract.config.reajust}
                        control={form.control}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-2">
                      <Toggle
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="signature"
                        onLabel="Contrato Assinado"
                        offLabel="Contrato Assinado"
                        preValue={contract.config.signature}
                        control={form.control}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-2">
                      <Toggle
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="scanned"
                        onLabel="Contrato Escaneado"
                        offLabel="Contrato Escaneado"
                        preValue={contract.config.scanned}
                        control={form.control}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 my-2">
                      <Toggle
                        disabled={permissions && !permissions.includes("64")} //Editar Configurações do Contrato
                        name="concluded"
                        onLabel="Contrato Concluído"
                        offLabel="Contrato Concluído"
                        preValue={contract.config.contract_completed}
                        control={form.control}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                    </div>
                  </div>
                  {permissions &&
                    permissions.includes("64") && ( //Editar Configurações do Contrato
                      <div className="d-flex justify-content-center">
                        <Button
                          type="submit"
                          icon="fa-solid fa-pen-to-square"
                          iconPos="right"
                          label="Editar"
                          loading={loading}
                          className="rounded-pill w-70"
                        />
                      </div>
                    )}
                </div>
              </div>
              {/* <div className="row d-flex justify-content-between"> */}
              {/* <div className="col-xl-2 col-md-6 d-flex justify-content-center">
                  <Button
                    type="submit"
                    icon="fa-solid fa-pen-to-square"
                    iconPos="right"
                    label="Editar"
                    loading={loading}
                    className="rounded-pill w-70"
                  />
                </div> */}

              {/* </div> */}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Contract;
